import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import GTPrfqs from "./GTPrfqs";
import Myrfqs from "./Myrfqs";
import Byerrfqs from "./Byerrfqs";

const AmtplRFQs = () => {
    const [activeTab, setActiveTab] = useState("My RFQs");
    const tabs = ["My RFQs", "GTP RFQs" ,"Buyer RFQs"];

    const renderTabContent = () => {
        switch (activeTab) {
            case "My RFQs":
                return <Myrfqs />;
            case "GTP RFQs":
                return <GTPrfqs />;
            case "Buyer RFQs":
                return <Byerrfqs />;
            default:
                return <Myrfqs />; // Added return statement
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AmtplRFQs;